import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';
import VueCookies from 'vue-cookies';
import $store from '@/store'

// * Exactly the same as the original onboarding service, but the endpoints lead to onboarding v2.

export class OnboardingService extends BaseService {
  static getGclid() {
    return VueCookies.get('winona_gclid') || null;
  }

  static getTbclid() {
    return VueCookies.get('winona_tbclid') || null;
  }

  static getTtclid() {
    return VueCookies.get('winona_ttclid') || null;
  }

  static async getDeduplicationID() {
    return await $store.dispatch('getDeduplicationID');
  }

  static async collectEmail(body) {
    try {
      const config = { headers: {} };
      const campaign = await this.getCookieUTMS();
      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }
      
      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }
      
      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }
      
      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }

      try {
        const fbp = VueCookies.get('_fbp') || null;
        const fbc = VueCookies.get('_fbc') || null;
        if (fbp) {
          config.headers.fbp = fbp;
        }
        if (fbc) {
          config.headers.fbc = fbc;
        }
      } catch (err) {
        console.log(err);
      }
      
      const response = await this.request({ auth: false }).post(
        '/patient/base',
        body,
        config
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async onboardingEvent(eventname, data) {
    try {
      const config = { headers: {} };
      const campaign = await this.getCookieUTMS();
      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }

      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }

      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }

      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }
      
      try {
        const fbp = VueCookies.get('_fbp') || null;
        const fbc = VueCookies.get('_fbc') || null;
        if (fbp) {
          config.headers.fbp = fbp;
        }
        if (fbc) {
          config.headers.fbc = fbc;
        }
      } catch (err) {
        console.log(err);
      }

      const body = data ? data : null;

      const response = await this.request({ auth: false, trackFB: true }).put(
        `/integromat/events/${eventname}`,
        body,
        config
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async onboardingIdentify(body) {
    // Don't forget to add the user's ID
    // Supply eventname as OnboardingIdentify
    try {
      const response = await this.request({ auth: false, trackFB: true }).put(
        '/integromat/events/OnboardingIdentify',
        body
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async rejectOnboardingEvent(body) {
    try {
      const response = await this.request({ auth: true, authKey: true }).post(
        '/patient/onboardingv2/reject',
        body
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getPatientOnboarding () {
    try {
      const redesignFlows = ['C', 'D1','D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'];
      const response = await this.request({ auth: true, trackFB: true }).get(
        '/patient/onboardingv2'
      );
      if (response.data?.body) {
        const flowVariant = response.data?.body?.flow_variant;
        const isRedesignFlow = redesignFlows.includes(flowVariant)
        $store.commit('global/SET_ONBOARDING_REDESIGN', isRedesignFlow, { root: true });
      } else {
        $store.commit('global/SET_ONBOARDING_REDESIGN', true, { root: true });
      }

      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async updateTreatmentForm(data, config = {}) {
    try {
      const response = await this.request({ auth: true, trackFB: true }).put(
        '/patient/onboardingv2/updatetreatmentform',
        data,
        config
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async getCookieUTMS() {
    let campaign = undefined;
    const winona_utms = VueCookies.get('winona_utms') || undefined;

    if (winona_utms != undefined && winona_utms.constructor.name === 'Object') {
      const utm_name = winona_utms.utm_name || winona_utms.utm_campaign || undefined;
      const utm_source = winona_utms.utm_source || undefined;
      const utm_medium = winona_utms.utm_medium || undefined;
      const utm_campaign = winona_utms.utm_campaign || undefined;
      const utm_term = winona_utms.utm_term || undefined;
      const utm_content = winona_utms.utm_content || undefined;
      const utm_id = winona_utms.utm_id || undefined;
      const utm_site = winona_utms.utm_site || undefined;
      const utm_audience = winona_utms.utm_audience || undefined;
      const utm_placement = winona_utms.utm_placement || undefined;
      if (
        utm_source != undefined ||
        utm_name != undefined ||
        utm_medium != undefined ||
        utm_campaign != undefined ||
        utm_term != undefined ||
        utm_content != undefined ||
        utm_id != undefined ||
        utm_site != undefined ||
        utm_audience != undefined ||
        utm_placement != undefined
      ) {
        campaign = {};
      }
      if (utm_name != undefined) {
        campaign['utm-name'] = utm_name;
      }
      if (utm_source != undefined) {
        campaign['utm-source'] = utm_source;
      }
      if (utm_medium != undefined) {
        campaign['utm-medium'] = utm_medium;
      }
      if (utm_campaign != undefined) {
        campaign['utm-campaign'] = utm_campaign;
      }
      if (utm_term != undefined) {
        campaign['utm-term'] = utm_term;
      }
      if (utm_content != undefined) {
        campaign['utm-content'] = utm_content;
      }
      if (utm_id != undefined) {
        campaign['utm-campaignid'] = utm_id;
      }
      if (utm_site != undefined) {
        campaign['utm-site'] = utm_site;
      }
      if (utm_audience != undefined) {
        campaign['utm-audience'] = utm_audience;
      }
      if (utm_placement != undefined) {
        campaign['utm-placement'] = utm_placement;
      }

      // Converts objects to strings
      for (const utmkey in campaign) {
        if (typeof campaign[utmkey] == 'Object') {
          campaign[utmkey] = JSON.stringify(campaign[utmkey]);
          // if utm is a string, convert to ISO 8859-1 friendly format
        } else if (typeof campaign[utmkey] == 'string') {
          campaign[utmkey] = encodeURIComponent(campaign[utmkey]);
        }
      }
    }
    return campaign;
  }

  static async getCookieFirstTouchUTMS() {
    let campaign = undefined;
    const winona_firsttouch_utms =
      VueCookies.get('winona_firsttouch_utms') || undefined;

    if (
      winona_firsttouch_utms != undefined &&
      winona_firsttouch_utms.constructor.name === 'Object'
    ) {
      const utm_name = winona_firsttouch_utms.utm_name || undefined;
      const utm_source = winona_firsttouch_utms.utm_source || undefined;
      const utm_medium = winona_firsttouch_utms.utm_medium || undefined;
      const utm_campaign = winona_firsttouch_utms.utm_campaign || undefined;
      const utm_term = winona_firsttouch_utms.utm_term || undefined;
      const utm_content = winona_firsttouch_utms.utm_content || undefined;
      const utm_id = winona_firsttouch_utms.utm_id || undefined;
      const utm_site = winona_firsttouch_utms.utm_site || undefined;
      const utm_audience = winona_firsttouch_utms.utm_audience || undefined;
      const utm_placement = winona_firsttouch_utms.utm_placement || undefined;

      if (
        utm_source != undefined ||
        utm_name != undefined ||
        utm_medium != undefined ||
        utm_campaign != undefined ||
        utm_term != undefined ||
        utm_content != undefined ||
        utm_id != undefined ||
        utm_site != undefined ||
        utm_audience != undefined ||
        utm_placement != undefined
      ) {
        campaign = {};
      }
      if (utm_name != undefined) {
        campaign['firsttouch-utm-name'] = utm_name;
      }
      if (utm_source != undefined) {
        campaign['firsttouch-utm-source'] = utm_source;
      }
      if (utm_medium != undefined) {
        campaign['firsttouch-utm-medium'] = utm_medium;
      }
      if (utm_campaign != undefined) {
        campaign['firsttouch-utm-campaign'] = utm_campaign;
      }
      if (utm_term != undefined) {
        campaign['firsttouch-utm-term'] = utm_term;
      }
      if (utm_content != undefined) {
        campaign['firsttouch-utm-content'] = utm_content;
      }
      if (utm_id != undefined) {
        campaign['firsttouch-utm-campaignid'] = utm_id;
      }
      if (utm_site != undefined) {
        campaign['firsttouch-utm-site'] = utm_site;
      }
      if (utm_audience != undefined) {
        campaign['firsttouch-utm-audience'] = utm_audience;
      }
      if (utm_placement != undefined) {
        campaign['firsttouch-utm-placement'] = utm_placement;
      }
      
      // Converts objects to strings
      for (const utmkey in campaign) {
        if (typeof campaign[utmkey] == 'Object') {
          campaign[utmkey] = JSON.stringify(campaign[utmkey]);
          // if utm is a string, convert to ISO 8859-1 friendly format
        } else if (typeof campaign[utmkey] == 'string') {
          campaign[utmkey] = encodeURIComponent(campaign[utmkey]);
        }
      }
    }
    return campaign;
  }

  static async updatePatientOnboarding(step, data, config = {}) {
    try {
      const campaign = await this.getCookieUTMS();
      config.headers = {}

      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }

      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }

      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }

      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }

      if (typeof EF !== 'undefined') {
        const transaction_id = EF.getAdvertiserTransactionId(1);
        if (EF && transaction_id) {
          if (!config.headers) {
            config.headers = { 'everflow-transaction-id': transaction_id };
          } else {
            config.headers['everflow-transaction-id'] = transaction_id;
          }
          console.log(config.headers)
        }
      }

      let response;

      if (step == 7) {
        // Retry disabling
        response = await this.request({
          auth: true,
          trackFB: true,
          noRetry: true,
        }).put(`/patient/onboardingv2/step/${step}`, data, config);
      } else {
        response = await this.request({ auth: true, trackFB: true }).put(
          `/patient/onboardingv2/step/${step}`,
          data,
          config
        );
      }

      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      if (step === 6) throw error;
      if (step === 7) throw new ErrorWrapper(error, null);
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async updatePatientUpsell(data, config = {}) {
    try {
      const campaign = await this.getCookieUTMS();
      config.headers = {}

      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }

      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }

      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }

      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }

      if (typeof EF !== 'undefined') {
        const transaction_id = EF.getAdvertiserTransactionId(1);
        if (EF && transaction_id) {
          if (!config.headers) {
            config.headers = { 'everflow-transaction-id': transaction_id };
          } else {
            config.headers['everflow-transaction-id'] = transaction_id;
          }
          console.log(config.headers)
        }
      }

      const response = await this.request({ auth: true, trackFB: true }, 'v2').post(
        '/onboarding/upsell/accept',
        data,
        config
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async updatePatientPhotoV2(data, config = {}) {
    try {
      const campaign = await this.getCookieUTMS();
      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }

      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }

      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }

      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }

      if (typeof EF !== 'undefined') {
        const transactionId = EF.getAdvertiserTransactionId(1);
        if (EF && transactionId) {
          if (!config.headers) {
            config.headers = { 'everflow-transaction-id': transactionId };
          } else {
            config.headers['everflow-transaction-id'] = transactionId;
          }
          console.log(config.headers)
        }
      }

      const response = await this.request({ auth: true, trackFB: true }, 'v2').post(
        '/onboarding/patient/photo',
        data,
        config
      );
      
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async triggerOnboardingEvents(data, config = {}) {
    try {
      const campaign = await this.getCookieUTMS();
      const config = { headers: {} };

      if (campaign) {
        config.headers = campaign;
      }

      const ftcampaign = await this.getCookieFirstTouchUTMS();
      if (ftcampaign) {
        config.headers = { ...campaign, ...ftcampaign };
      }

      const gclid = this.getGclid();
      if (gclid) {
        config.headers.gclid = gclid;
      }

      const tbclid = this.getTbclid();
      if (tbclid) {
        config.headers.tbclid = tbclid;
      }

      const ttclid = this.getTtclid();
      if (ttclid) {
        config.headers.ttclid = ttclid;
      }

      const deduplicationID = await this.getDeduplicationID();
      if (deduplicationID) {
        config.headers['deduplicationid'] = deduplicationID;
      }

      const response = await this.request({ auth: true, trackFB: true }).put(
        '/patient/onboardingv2/triggerevent',
        data,
        config
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getHealthQuestion(step) {
    try {
      const response = await this.request({ auth: true, trackFB: true }).get(
        `/patient/onboardingv2/step/${step}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getPreviousHealthQuestion(step) {
    try {
      const response = await this.request({ auth: true, trackFB: true }).get(
        `/patient/onboardingv2/step/${step}/previous`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getProductReveal() {
    try {
      const response = await this.request({ auth: true, trackFB: true }).get(
        '/patient/onboardingv2/productreveal'
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getProductRevealView(treatmentform) {
    try {
      const response = await this.request({ auth: true }).get(
        `/patient/onboardingv2/productreveal?treatmentform=${treatmentform}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async applyCoupon(data) {
    try {
      const response = await this.request({ auth: true }).put(
        '/patient/onboardingv2/applycoupon',
        data
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async removeCoupon() {
    try {
      const response = await this.request({ auth: true }).delete(
        '/patient/onboardingv2/removecoupon'
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }

  static async checkCoupon(couponid) {
    try {
      const response = await this.request({ auth: false }).get(
        `/coupon/${couponid}`
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async sendSASClickId(clickid) {
    try {
      const response = await this.request({ auth: true }).put(
        '/patient/onboardingv2/shareasale',
        {
          shareasaleclickid: clickid,
        }
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async acceptTermsAndConditions() {
    try {
      const response = await this.request({ auth: true }, 'v2').put(
        '/patient/acceptednewterms'
      );

      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async verifySSN(ssn) {
    try {
      const response = await this.request({ auth: true, noRetry: true, }, 'v2').post(
        '/onboarding/patient/verify',
        { ssn }
      );

      return response
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }

  static async getNonHRTOnboarding() {
    try {
      const response = await this.request({ auth: true }, 'v2').get(
        '/onboarding/upsell'
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, null);
    }
  }
  
  static async submitPeanutAllergy(patientid, data) {
    try {
      const response = await this.request({ auth: true }).put(
        `/patient/${patientid}/allergy`,
        data
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, null, 'onboarding');
    }
  }
}